import { useState } from 'react';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Dialog } from '@/components/Dialog';
import Markdown from '@/components/Markdown';
import downloadTextFileFromDatalake from '@/utils/downloadTextFileFromDatalake';

import { FeedArticleDialogSkeleton } from './FeedArticleDialogSkeleton';

export const FeedArticleDialogLink = ({
  CTAValue,
  CTALabel
}: {
  CTAValue: string;
  CTALabel?: string;
}) => {
  const [open, setOpen] = useState(false);

  const { data, isLoading, error } = useQuery({
    queryKey: ['datalake', 'file', CTAValue],
    enabled: open,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const [groupName, fileName] = CTAValue.split('/');
      return downloadTextFileFromDatalake(fileName, groupName);
    }
  });

  return (
    <>
      <Link
        color='#E84E0F'
        component='button'
        sx={{
          textDecoration: 'none',
          verticalAlign: 'baseline',
          display: 'inline-flex',
          alignItems: 'center'
        }}
        onClick={() => {
          setOpen(true);
        }}
      >
        {CTALabel ?? 'See the article'}
        <ChevronRightIcon sx={{ fontSize: '1em' }} />
      </Link>
      <Dialog
        closeIcon
        open={open}
        sx={{ minWidth: 800 }}
        onClose={() => {
          setOpen(false);
        }}
      >
        {isLoading && <FeedArticleDialogSkeleton />}
        {error && <Typography color='error'>"error"</Typography>}
        {!isLoading && !error && data && (
          <Typography
            component='div'
            sx={{
              overflowWrap: 'break-word',
              hyphens: 'auto',
              fontSize: '14px',
              marginTop: '-38px'
            }}
          >
            <Markdown>{data}</Markdown>
          </Typography>
        )}
      </Dialog>
    </>
  );
};
